import React from "react";

// Stylesheet
import "./Copy.css";

// Material UI Icons
import ContentCopyIcon from "@mui/icons-material/ContentCopy";

// Copy to clipboard
import { useClipboard } from "use-clipboard-copy";
import { toast } from "react-hot-toast";

function Copy({ url }) {
  const clipboard = useClipboard({
    onSuccess() {
      console.log("Address was copied successfully!");
      toast.success("Address was copied successfully!");
    },
    onError() {
      console.log("Failed to copy address!");
      toast.error("Failed to copy address!");
    },
  });

 //put ellipsis in middle of text
 function putEllipsisInMiddle(text, maxLength) {
  if (text.length > maxLength) {
    let firstHalf = text.substring(0, Math.floor(maxLength / 2));
    let secondHalf = text.substring(text.length-10);
    return firstHalf + "...." + secondHalf;  
  }
  return text;
}
  return (
    <div className="copy-clipboard">
      <input value={putEllipsisInMiddle(url,20)} readOnly />
      <input ref={clipboard.target} type="hidden" value={url} readOnly />
      <button onClick={clipboard.copy}>
        <ContentCopyIcon />
      </button>
    </div>
  );
}

export default Copy;
